// import axios from 'axios';
// import Constant from './Constant';



// export async function getApi(url, { header }) {
//     console.log(
//         'GetApi: ',
//         `${Constant.BASE_URL}/${url}`,
//         'header',
//         `${JSON.stringify(header)}`,
//     );

//     return await axios
//         .get(`${Constant.BASE_URL}/${url}`, {
//             headers: {
//                 Accept: header.Accept,
//                 'x-access-token': header.accesstoken,
//                 'Content-type': header.contenttype,
//             },
//         })
//         .catch(error => {
//             // ShowAlert('something went wrong');
//             console.log('error: =========>', error);
//         });
// }

// export async function getApiWithParam(url, param, header) {
//     console.log('getApiWithParam: ', `${constant.BASE_URL}/${url}/${param}`);
//     return await axios
//         .get(`${constants.BASE_URL}/${url}/${Number(param)}`, {
//             headers: {
//                 Accept: header.Accept,
//                 'x-access-token': header.accesstoken,
//                 'Content-type': header.contenttype,
//             },
//         })
//         .catch(error => {
//             ShowAlert('something went wrong');
//             console.log('error: =========>', error);
//         });
// }

// export async function postApi(url, payload, { header }) {
//     console.log('PostApi: ', `${constants.BASE_URL}/${url}`, header, payload);

//     return await axios
//         .post(`${constants.BASE_URL}/${url}`, payload, {
//             headers: {
//                 Accept: header.Accept,
//                 'x-access-token': header.accesstoken,
//                 'Content-type': header.contenttype,
//             },
//         })
//         .catch(error => {
//             ShowAlert('something went wrong');
//             console.log('error: =========>', error);
//         });
// }
import axios from 'axios';
import Constant from './Constant';

export async function getApi(url, { header }) {
    console.log(
        'GetApi: ',
        `${Constant.BASE_URL}/${url}`,
        'header',
        `${JSON.stringify(header)}`,
    );

    return await axios
        .get(`${Constant.BASE_URL}/${url}`, {
            headers: {
                Accept: header.Accept,
                'x-access-token': header.accesstoken,
                'Content-type': header.contenttype,
            },
        })
        .catch(error => {
            console.log('error: =========>', error);
            throw error; // It's better to throw the error to be caught by the calling function
        });
}

export async function postApi(url, payload, header = {}) {
    console.log('PostApi: ', `${Constant.BASE_URL}/${url}`, payload);

    return await axios
        .post(`${Constant.BASE_URL}/${url}`, payload, {
            headers: {
                'Accept': 'application/json',
                'Content-type': 'application/json',
                ...header,
            },
        })
        .catch(error => {
            console.log('error: =========>', error);
            throw error; // Propagate the error
        });
}